module.exports = __webpack_public_path__ + "static/media/house-2.8a628de8.png";